<template>
  <div id="products" class="cart animated fadeIn pb4">
    <!-- desktop view -->
    <div>
      <WebshopHeader>
      </WebshopHeader>
      <div class="clearfix" v-if="loading">
        <div class="col-12">
          <div class="loader"></div>
        </div>
      </div>
      <div class="py4 px3" v-else>
        <div class="pt2"></div>
        <!--  <h4 class="darkblue bold">Indkøbskurv</h4>-->
        <div class="py3">
          <div class="p0">
            <div class="el-table el-table--fit el-table--enable-row-hover el-table--enable-row-transition" v-if="cartMsg == ''">
              <!-- <div class="right-align">
                <el-pagination
                  small
                  layout="prev, pager, next"
                  :total="parseInt(lastPage)" @current-change="paginationChanged" :current-page="parseInt(curPage)">
                </el-pagination>
              </div> -->
              <!-- <div class="clearfix" v-if="insideLoading">
                <div class="col-12">
                  <div class="loader"></div>
                </div>
              </div>
              <div v-else> -->
              <div>
                <table class="el-table__body col-12 p0">
                  <thead class="has-gutter">
                    <tr>
                      <th colspan="1" rowspan="1" class="el-table_1_column_1 is-leaf">Produkt</th>
                      <th colspan="1" rowspan="1" class="el-table_1_column_1 is-leaf">Antal</th>
                      <th colspan="1" rowspan="1" class="el-table_1_column_1 is-leaf">Pris</th>
                      <th colspan="1" rowspan="1" class="el-table_1_column_1 is-leaf">Sum</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="el-table__row" v-for="(cart,index) in cartData" :key="index">
                      <td class="el-table_1_column_1">
                        <a :href="'#/webshop/product?id='+cart.PRODUCT_ID" class="mintgreen flex items-center">
                          <img :src="'https://newcrm.kundematch.dk' + cart.get_product_image[0].showURL" class="mr1" width="20%" v-if="cart.PRODUCT_GROUP != '9001' && cart.NEED_GRAPHIC_HELP !== 'Yes'">
                          <img :src="cart.IMAGE_URL" class="mr1" width="20%">
                          <span class="bold">{{cart.PRODUCT_NAME}}</span>
                        </a>
                      </td>
                      <td class="el-table_1_column_1 qty">
                        <b-form-input :id="cart.PRODUCT_ID.toString()" type="number" min="1" style="text-align:right;" :value="parseInt(cart.QUANTITY)" class='qty' @keyup="updateQuantity(cart.PRODUCT_ID)" disabled @change="updateQuantity(cart.PRODUCT_ID)" v-if="cart.NEED_GRAPHIC_HELP === 'Yes'"></b-form-input>
                        <b-form-input :id="cart.PRODUCT_ID.toString()" type="number" min="1" style="text-align:right;" :value="parseInt(cart.QUANTITY)" class='qty' @keyup="updateQuantity(cart.PRODUCT_ID)"  @change="updateQuantity(cart.PRODUCT_ID)" v-else></b-form-input>
                      </td>

                      <td class="el-table_1_column_1 price"><span>{{(parseFloat(cart.PRICE)).toLocaleString("da", {style: "currency", currency: "DKK"}).replaceAll('.', ' ').replaceAll(',', '.')}}</span></td>

                       <td class="el-table_1_column_1 price"><span>{{(parseFloat(cart.PRICE * cart.QUANTITY)).toLocaleString("da", {style: "currency", currency: "DKK"}).replaceAll('.', ' ').replaceAll(',', '.')}}</span><a class="pointer absolute right-0 mr2" title="Remove"  @click="confirmDelete(cart.PRODUCT_ID)"><i class="el-icon-error h5 red"></i></a></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="mt3"><span class="bold">{{cartMsg}}</span></div>
          </div>
          <div class="lg-flex pt2" v-if="cartMsg == ''">
            <div class="block col-12 right-align p0">
              <table class="total-amount inline-block mb1">
                <tr class="h6 bold">
                  <td>Levering:</td>
                  <td><span class="total">{{(parseFloat(deliveryFee)).toLocaleString("da", {style: "currency", currency: "DKK"}).replaceAll('.', ' ').replaceAll(',', '.')}}</span></td>
                </tr>
                <tr class="h6 bold">
                  <td>Total:</td>
                  <td><span class="total">{{(parseFloat(totalAmount)).toLocaleString("da", {style: "currency", currency: "DKK"}).replaceAll('.', ' ').replaceAll(',', '.')}}</span></td>
                </tr>
              </table>
              <div class="mb2"></div>
              <div>
                <a class="btn white action-button py2 px3 m0 gibson not-rounded border-none regular btn-secondary" @click="checkQuantity()">AFSLUT OG BETAL <i class="el-icon-right"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <WebshopFooter v-if="!loading">
      </WebshopFooter>
    </div>
  </div>
</template>

<script>
import WebshopHeader from './header'
import WebshopFooter from './footer'
export default {
  name: '',
  components: {
    WebshopHeader,
    WebshopFooter
  },
  data () {
    return {
      loading: true,
      insideLoading: false,
      salesPerson: '',
      haaId: '',
      cartData: [],
      deliveryFee: 0,
      currency: 'kr',
      totalAmount: 0,
      cartMsg: 'Ingen Varer I Din Kurv.',
      curPage: 1,
      lastPage: 10
    }
  },
  created () {
    this.salesPerson = localStorage.getItem('id_token_portal')
    this.haaId = localStorage.getItem('haaid')
    this.getDeliveryFee()
  },
  methods: {
    showBreadCrumb () {
      document.querySelector('.breadCrumb').classList.remove('hide')
    },
    displayCart () {
      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'webshop/GetCart/' + this.haaId + '?page=' + this.curPage
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (typeof res !== 'undefined' && res !== null && res.success) {
            var dataRes = response.data.data.data[0].webshop_cart_products
            this.cartData = dataRes.reverse()
            // var accCur = response.data.data.data[0].ACCOUNT_CURRENCY_ID
            var pagLastPage = response.data.data.last_page + '0'
            var price = 0
            var qty = 0
            var total = 0
            this.cartData.forEach(element => {
              if (element['get_product_image'].length === 0) {
                var defaultprod = {
                  'ID': 8903,
                  'IBLOCK_PROPERTY_ID': 98,
                  'IBLOCK_ELEMENT_ID': 11682,
                  'VALUE': '3502',
                  'TIMESTAMP_X': '2022-01-26 13:16:00',
                  'CONTENT_TYPE': 'image/jpeg',
                  'HEIGHT': 788,
                  'WIDTH': 732,
                  'FILE_SIZE': 47521,
                  'FILE_NAME': '40035 4.jpg',
                  'ORIGINAL_NAME': '40035 4.jpg',
                  'SUBDIR': 'iblock/e64/fofm5650a15jentoqk6xeuzxyucar8mx',
                  'showURL': '/upload/iblock/e64/fofm5650a15jentoqk6xeuzxyucar8mx/40035 4.jpg'
                }
                element['get_product_image'].push(defaultprod)
              }
            })
            for (var i = 0; i < dataRes.length; i++) {
              price = dataRes[i].PRICE
              qty = dataRes[i].QUANTITY
              total += price * qty
            }
            // this.currency = accCur
            this.totalAmount = total + parseInt(this.deliveryFee)
            if (Number.isInteger(this.totalAmount)) {
              this.totalAmount = this.totalAmount + '.00'
            }
            this.lastPage = pagLastPage
            if (!dataRes.length) {
              this.cartMsg = 'Ingen Varer I Din Kurv.'
            } else {
              this.cartMsg = ''
            }
            this.showBreadCrumb()
            this.loading = false
          } else {
            this.showBreadCrumb()
            this.loading = false
            console.log('Error in displayCart()')
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
    },
    getDeliveryFee () {
      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'webshop/GetWebshopDeliveryChargeDynamic/9001' // static for badges
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.deliveryFee = res.data.PRICE
            this.displayCart()
          } else {
            console.log('Error in getDeliveryFee()')
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
    },
    updateQuantity (id) {
      const qty = document.getElementById(id).value
      if (!isNaN(qty) && qty >= 1) {
        var data = {
          operation: 'bitrixApi',
          salesPerson: this.salesPerson,
          type: 'POST',
          url: 'webshop/ModifyCart/0/' + this.haaId + '/' + id + '/' + qty
        }
        this.$http.post('', data, { emulateJSON: true }).then(
          (response) => {
            var res = response.body
            if (res.success) {
              this.displayCart()
              this.calulateCartCount()
              this.$toastr('success', 'Opdateret')
            } else {
              console.log('Error in updateQuantity()')
            }
          },
          (response) => {
            console.log('Error: ', response)
          }
        )
      }
    },
    checkQuantity () {
      var input = document.querySelectorAll('input.qty')
      var redirect = true
      for (var i = 0; i < input.length; i++) {
        var qty = parseInt(input[i].value)
        if (qty <= 0 || isNaN(qty)) {
          redirect = false
        }
      }
      if (redirect) {
        this.$router.push('/webshop/checkout')
      } else {
        this.$toastr('error', 'Mængden skal være større end nul')
      }
    },
    confirmDelete (id) {
      this.deleteCart(id)
    },
    deleteCart (id) {
      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'POST',
        url: 'webshop/ModifyCart/-1/' + this.haaId + '/' + id + '/0'
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.displayCart()
            this.calulateCartCount()
            this.$toastr('success', 'Fjernet')
          } else {
            console.log('Error in deleteCart()')
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
    },
    calulateCartCount () {
      setTimeout(() => {
        const qty = document.querySelectorAll('input.qty')
        var totalQty = 0
        for (var i = 0; i < qty.length; i++) {
          totalQty += parseInt(qty[i].value)
        }
        document.querySelector('.totalCart').innerText = totalQty
      }, 1000)
    },
    paginationChanged (val) {
      var pagCurPage = (`${val}`)
      this.curPage = pagCurPage
      this.displayCart()
      this.insideLoading = true
    }
  }
}
</script>

<style>
  div .el-table td, .el-table th {
    width: 25%;
    padding: 1rem;
  }
</style>


// WEBPACK FOOTER //
// cart.vue?1a7eb642